import { endOfDay, startOfDay, startOfMonth, startOfQuarter, startOfWeek, startOfYear, subDays, subMonths, subWeeks, } from 'date-fns';
import { utcToZonedTime, zonedTimeToUtc } from 'date-fns-tz';
var TimePeriod;
(function (TimePeriod) {
    TimePeriod["Today"] = "Today";
    TimePeriod["Yesterday"] = "Yesterday";
    TimePeriod["Last7Days"] = "Last 7 days";
    TimePeriod["Last4Weeks"] = "Last 4 weeks";
    TimePeriod["Last3Months"] = "Last 3 months";
    TimePeriod["Last12Months"] = "Last 12 months";
    TimePeriod["WeekToDate"] = "Week to date";
    TimePeriod["MonthToDate"] = "Month to date";
    TimePeriod["QuarterToDate"] = "Quarter to date";
    TimePeriod["YearToDate"] = "Year to date";
    TimePeriod["Total"] = "Total";
    TimePeriod["Custom"] = "Custom";
})(TimePeriod || (TimePeriod = {}));
export const getDateRangeFromPeriod = (period, timezone, returnAsUtcDates) => {
    let start = startOfDay(utcToZonedTime(new Date(), timezone));
    let end = endOfDay(utcToZonedTime(new Date(), timezone));
    switch (period) {
        case TimePeriod.Today: {
            break;
        }
        case TimePeriod.Yesterday: {
            start = subDays(start, 1);
            end = subDays(end, 1);
            break;
        }
        case TimePeriod.Last7Days: {
            start = subDays(start, 7);
            end = subDays(end, 1);
            break;
        }
        case TimePeriod.Last4Weeks: {
            start = subWeeks(start, 4);
            end = subDays(end, 1);
            break;
        }
        case TimePeriod.Last3Months: {
            start = subDays(start, 1);
            start = subMonths(start, 3);
            end = subDays(end, 1);
            break;
        }
        case TimePeriod.Last12Months: {
            start = subDays(start, 1);
            start = subMonths(start, 12);
            end = subDays(end, 1);
            break;
        }
        case TimePeriod.WeekToDate: {
            start = startOfWeek(start, { weekStartsOn: 1 });
            break;
        }
        case TimePeriod.MonthToDate: {
            start = startOfMonth(start);
            break;
        }
        case TimePeriod.QuarterToDate: {
            start = startOfQuarter(start);
            break;
        }
        case TimePeriod.YearToDate: {
            start = startOfYear(start);
            break;
        }
        case TimePeriod.Total: {
            start = subDays(start, 7);
            end = subDays(end, 1);
            break;
        }
        default: {
            start = subDays(start, 7);
            end = subDays(end, 1);
            break;
        }
    }
    return {
        startDate: returnAsUtcDates ? start : zonedTimeToUtc(start, timezone),
        endDate: returnAsUtcDates ? end : zonedTimeToUtc(end, timezone),
    };
};
//# sourceMappingURL=dateRangeUtils.js.map